import { getEnvironmentConfig } from './environment';

const { AUTH_CALLBACK_URL, AUTH_CALLBACK_ORIGIN, MS_CLIENT_ID, MS_AUTHORITY } = getEnvironmentConfig();

interface MicrosoftAuthStatePayload {
  nonce: string;
  tenantOrigin: string;
  timestamp: number;
}

const MICROSOFT_SCOPES = ['openid', 'profile', 'email'].join(' ');

const encodeState = (state: MicrosoftAuthStatePayload): string => {
  return window.btoa(JSON.stringify(state));
};

export const decodeState = (encodedState: string): MicrosoftAuthStatePayload | null => {
  try {
    const decoded = window.atob(encodedState);
    const parsed = JSON.parse(decoded) as MicrosoftAuthStatePayload;
    if (!parsed.tenantOrigin || !parsed.nonce || !parsed.timestamp) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const isAllowedTenantOrigin = (origin: string): boolean => {
  try {
    const parsed = new URL(origin);
    const isHttpsBluelt = parsed.protocol === 'https:' && parsed.hostname.endsWith('.blueltsystem.com.br');
    const isLocal = parsed.protocol === 'http:' && (parsed.hostname === 'localhost' || parsed.hostname.endsWith('.localhost'));
    return isHttpsBluelt || isLocal;
  } catch {
    return false;
  }
};

const createNonce = (): string => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const buildMicrosoftAuthorizeUrl = (tenantOrigin: string): string => {
  const authorityBase = MS_AUTHORITY.replace(/\/+$/, '');
  const authEndpoint = `${authorityBase}/oauth2/v2.0/authorize`;
  const state = encodeState({
    nonce: createNonce(),
    tenantOrigin,
    timestamp: Date.now(),
  });

  const params = new URLSearchParams({
    client_id: MS_CLIENT_ID,
    response_type: 'id_token',
    redirect_uri: AUTH_CALLBACK_URL,
    response_mode: 'fragment',
    scope: MICROSOFT_SCOPES,
    nonce: createNonce(),
    state,
  });

  return `${authEndpoint}?${params.toString()}`;
};

export const MICROSOFT_CALLBACK_ORIGIN = AUTH_CALLBACK_ORIGIN;
